import { getDisabledStateFromLifecycleStatuses } from "../utilities/lifecycleStatus";

export const getResendButtonText = (record, defaultText) => {
	return record.displayStatus === "Revoked"
		? "Re-Share and resend email"
		: defaultText;
};

export const getActionDisableMessage = ({
	canSeeAllShares,
	cognitoSub,
	record,
	userAction,
}) => {
	const matterLifecycleStatus = record.matterLifecycleStatus;
	const matterLifecycleStatusObject = getDisabledStateFromLifecycleStatuses({
		matterLifecycleStatus,
	});
	switch (userAction) {
		case "revoke":
			if (record.displayStatus === "Expired") {
				return "This Share has expired";
			} else if (record.status !== "active") {
				return "Only active shares can be revoked.";
			} else if (record.createdBySub !== cognitoSub && !canSeeAllShares) {
				return "You do not have the right to revoke this share.";
			}
			break;
		case "resend":
			if (record.displayStatus === "Expired") {
				return "This Share has expired";
			} else if (matterLifecycleStatusObject.IN_TRASH) {
				return "A share cannot be resent for a Matter in the Trash Bin. Please restore the Matter first.";
			} else if (matterLifecycleStatusObject.IN_ARCHIVE) {
				return "A share cannot be resent for a Matter in the Archive. Please restore the Matter first.";
			} else if (record.matterWasPermanentlyDeleted) {
				return "Cannot resend share for a permanently deleted matter.";
			} else if (record.createdBySub !== cognitoSub && !canSeeAllShares) {
				return "You do not have the right to resend this share.";
			}
			break;
		case "copyDownloadLink":
			if (record.matterWasPermanentlyDeleted) {
				return "Cannot copy download link for a share of a permanently deleted matter.";
			}
			break;
		default:
			console.error("unrecognized userAction", { userAction });
	}
};
